import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 24 24"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 16L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 16M16 8L12 4M12 4L8 8M12 4L12 16" />
  </svg>
);
